import { useEffect, useState } from "react";
import { ebayAPI } from "@/lib/api";

/**
 * Tiny SANDBOX badge in the top-right corner — only renders when the backend
 * is pointing at eBay's sandbox environment. Prevents you from accidentally
 * confusing a sandbox session for the real thing.
 */
export default function EnvBadge() {
  const [env, setEnv] = useState(null);

  useEffect(() => {
    let alive = true;
    ebayAPI
      .env()
      .then((r) => {
        if (alive) setEnv(r.data);
      })
      .catch(() => {
        // Silent fail — endpoint may not exist in older deploys
      });
    return () => {
      alive = false;
    };
  }, []);

  if (!env || !env.is_sandbox) return null;

  return (
    <div
      className="fixed top-2 right-2 z-[10400] pointer-events-none select-none"
      data-testid="env-sandbox-badge"
      aria-label="Sandbox environment"
    >
      <div className="border-2 border-black bg-[#FFD500] text-black px-2 py-0.5 font-heading text-[10px] font-bold uppercase tracking-[0.15em] shadow-[2px_2px_0px_0px_rgba(0,0,0,1)]">
        eBay Sandbox
      </div>
    </div>
  );
}
